import {NotificationsApi} from '@src/api/notifications-api';
import {UserApi} from '@src/api/user-api';
import {PaginationLogic} from '@src/commonlogic/PaginationLogic';
import {imagesService} from '@src/features/images/logic/images-service';
import {useQuery} from 'react-query';

export const userKeys = {
  avatar: () => ['avatar'],
  notificationsNotInfinite: () => ['notifications-not-infinite'],
  myUser: () => ['myUser'],
};

export function useUserAvatarQuery() {
  return useQuery({
    queryKey: userKeys.avatar(),
    queryFn: () => imagesService.getUserAvatar(),
    staleTime: 1 * 60 * 1000, // 1 minute
    cacheTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useNotificationsNotInfiniteQuery(token: string) {
  return useQuery({
    queryKey: userKeys.notificationsNotInfinite(),
    queryFn: ({pageParam = 1}) => {
      return NotificationsApi.getNotifications({page: pageParam}, token);
    },
    getNextPageParam: PaginationLogic.handleGetNextParam,
    enabled: token !== '',
    staleTime: 100,
  });
}

export function useMyUserQuery() {
  return useQuery({
    queryKey: userKeys.myUser(),
    queryFn: () => UserApi.getCurrentUser(),
  });
}
